const Tag = {
  baseStyle: {
    container: {
      color: "black",
      backgroundColor: "grayscale.50",
      whiteSpace: "nowrap",
      cursor: "pointer",
      borderRadius: "pill",
      fontWeight: "bold",
      _light: {
        color: "black",
        backgroundColor: "grayscale.50"
      },
      _dark: {
        color: "white",
        backgroundColor: "grayscale.700",
        _hover: {
          backgroundColor: "#5a5a5a"
        }
      }
    },
    label: {
      fontWeight: "bold"
    },
    closeButton: {
      transition: "all 120ms ease-in-out",
      marginLeft: "0.875rem",
      backgroundColor: "transparent",
      _hover: {
        transform: "scale(1.1) rotate(15deg)"
      }
    }
  },
  sizes: {
    xs: {
      container: {
        px: "75"
      },
      label: {
        lineHeight: "1.375rem",
        fontSize: "text-sm"
      },
      closeButton: {
        pr: 0,
        marginLeft: "0rem",
        svg: {
          width: "0.75rem"
        }
      }
    },
    sm: {
      container: {
        px: "75",
        height: "2rem"
      },
      label: {
        lineHeight: "1.875rem",
        fontSize: "text"
      },
      closeButton: {
        marginLeft: "0.5rem",
        svg: {
          width: "0.95rem"
        }
      }
    },
    md: {
      container: {
        px: "100",
        height: "2.5rem"
      },
      label: {
        lineHeight: "2.375rem",
        fontSize: "text"
      },
      closeButton: {
        marginLeft: "0.625rem",
        fontSize: "text",
        svg: {
          width: "1.15rem"
        }
      }
    },
    lg: {
      container: {
        px: "200",
        fontSize: "text-lg",
        height: "3rem"
      },
      label: {
        lineHeight: "3rem"
      },
      closeButton: {
        fontSize: "text-lg",
        svg: {
          width: "1.35rem"
        }
      }
    },
    xl: {
      container: {
        px: "1.25rem"
      },
      label: {
        fontSize: "text-xl",
        lineHeight: "3.5rem"
      },
      closeButton: {
        fontSize: "text-xl",
        svg: {
          width: "1.5rem"
        }
      }
    }
  },
  defaultProps: {
    size: "md"
  }
};

export { Tag };
